/**
 * Performance monitoring and metrics
 */

export const metrics = {
  timers: new Map<string, number>(),
  
  startTimer(operation: string) {
    this.timers.set(operation, performance.now());
  },
  
  endTimer(operation: string) {
    const start = this.timers.get(operation);
    if (start) {
      const duration = performance.now() - start;
      this.logMetric(operation, duration);
    }
  },

  logMetric(operation: string, duration: number) {
    console.info('Channel Operation Metric:', {
      operation,
      duration,
      timestamp: new Date().toISOString()
    });
  }
};

export const withTiming = async <T>(
  operation: string,
  fn: () => Promise<T>
): Promise<T> => {
  metrics.startTimer(operation);
  try {
    return await fn();
  } finally {
    metrics.endTimer(operation);
  }
}; 